export const changeCard = {
  'Almost there!': 'Falta poco!',
  'Card change': 'Cambio de tarjeta',
  'CARD NAME': 'NOMBRE TARJETA',
  expiry: 'vencimiento',
  '{{name}}, to finalize the process, please provide a new credit card to avoid any headaches with future charges':
    '{{name}}, para finalizar el proceso, por favor informe una nueva tarjeta de crédito para evitar dolores de cabeza con futuras cobranzas',
};
